module.exports = __webpack_public_path__ + "static/img/6.9959ed5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/6/1/zh/6.png
// module id = GhQl
// module chunks = 0